<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else >
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <b-col >
                <h1>{{ecmResourceStrings.ttlRDBMSRepository}}</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4">
                <otif-button class="OTPrimary"  @click.native="save" id="otSave" :title="ecmResourceStrings.tipSaveECMRepository">{{ecmResourceStrings.lblSave}}</otif-button>
                <otif-button class="OTSecondary"  @click.native="cancel" id="otCancel" >{{ecmResourceStrings.lblCancel}}</otif-button>
            </b-col>
        </b-row>
         <b-row>
            <b-col class="OT-tabs">
                <SubNavbar :routes="routes" :ecmRepository="ecmRepository"></SubNavbar>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <router-view 
                    :selectedECMType ="ecmRepositoryType"
                    :ecmRepository="ecmRepository"
                    :parametersFromGrammar="parametersFromGrammar"
                    :realConfigurations="realConfigurations"
                    :realParametersConfigurations="realParametersConfigurations"
                    :availableParametersConfigurations="availableParametersConfigurations"
                    :realPartitionsConfigurations="realPartitionsConfigurations"
                    :availablePartitionsConfigurations="availablePartitionsConfigurations"
                    
                >
                </router-view>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import configRouteMappings from '@/ecm/routing/oticConfigRoutes.js';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import ecmRepository from '@/ecm/models/ecmrepository.js';
import ecmRepositoryType from '@/ecm/models/ecmrepositorytype.js';
import SubNavbar from '@/ecm/components/settings/SubpageBar.vue';

export default {

    props: {
        id:{
            required: true
        },
    },

    components: {
        SubNavbar,
        ECMErrorDialog,
    },

    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),  
            ecmRepositoryType:new ecmRepositoryType(),
            ecmRepository:new ecmRepository(),
            loaded: false,
            messageDlg: false,
            
            parametersFromGrammar:[],//all available parameters
            
            realConfigurations:[], // the parameters that user use
            originalConfigurations:[], //on edit keep all data from repository. Will be used to define what was changed on update
                
            //Parameters
            realParametersConfigurations:[], // the parameters that user use
            availableParametersConfigurations:[],//keep list of available parameters
            //Partitions
            realPartitionsConfigurations:[], // the parameters that user use
            availablePartitionsConfigurations:[],//keep list of available to fill combo in grid (listOfAttributess-realConfigurations)
        }
    },

    computed: {
        routes() {
            const routes = configRouteMappings['RDBMS Repository Configurations'];
            return routes;
        },
    },

    methods: {
        changeType($e) {
            const i = 0;
        },
    
        savingECMRepository() {
            this.$snotify.info(this.ecmResourceStrings.txtSavingECMRepository, {
                timeout: 0
            });
        },

        savedECMRepository() {
            this.$snotify.clear();
            this.$snotify.success(this.ecmResourceStrings.txtRDBMSRepositorySaved);
        },

        ECMRepositoryError($e) {
            this.$snotify.clear();
            if ($e.action === 'save') {
                this.$snotify.error($e.details.detail, this.ecmResourceStrings.errSavingECMRepository);
            } else {
                this.$snotify.error($e.details.detail, this.ecmResourceStrings.txtError);
            }
        },

        ECMRepositoryNotFound() {
            this.loaded = false;
            this.not_found = true;
        },

        cancel() {
            this.$router.push('/settings/rdbmsrepositories');
        },

        save()
        {
            const getData = this.createBodyPutString();
            const connString = getData.connString;
            const returnedstring = getData.returnedstring;
            this.$snotify.async('Saving ECM Repository', {timeout: 0});
            axios.put('/mtm-gateway-api/v1/services/ecm/ECMRepositories/' + this.ecmRepository.id, connString,  {headers: {"Content-Type": "application/json; charset=UTF-8"}})
             .then(() => {
                this.$snotify.clear();
                this.$snotify.success('ECM Repository Saved');
                this.$router.push('/settings/rdbmsrepositories');
             })
            .catch((err) => {
                if(err.response.statusText)
                {
                    this.$snotify.clear();
                    this.$snotify.error(this.ecmResourceStrings.errSavingECMRepository, err.response.statusText, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>this.$eventBus.$emit('show-error-ecm', this.ecmResourceStrings.errSavingECMRepository, err.response.statusText, err.response.data), bold: true },
                        ]
                    });
                }
                else{
                    this.$snotify.clear();
                    this.$snotify.error(this.ecmResourceStrings.errSavingECMRepository);
                }
            });
        },
    
        createBodyPutString : function()
        {
            var tempstring = "";
            var that = this;
            const lenreal = that.realConfigurations.length;
            const lenparam = that.realParametersConfigurations.length;
            //const lenconfparam =  that.realPartitionParametersConfigurations.length;
            const lenpartitions =  that.realPartitionsConfigurations.length;
            var configstring = "";
                    
            for (var cnt = 0; cnt < that.realConfigurations.length; cnt++)
            {
                if(that.realConfigurations[cnt])
                {
                    const configname = that.realConfigurations[cnt].name.trim();
                    const configtype = that.realConfigurations[cnt].type.trim();
                    var configvalueoriginal = "";
                    if(that.realConfigurations[cnt].value != null && that.realConfigurations[cnt].value != undefined)
                         configvalueoriginal = that.realConfigurations[cnt].value.toString().trim();
                    if(configvalueoriginal == undefined && configtype == 'string')
                        configvalueoriginal="";
                        //if config value contains '\' replace it to '\\'
                    var configvalue = "";
                    if(configtype == "string")
                    {   
                        if(configvalueoriginal.length > 0)
                        {
                            configvalue = JSON.stringify(configvalueoriginal); 
                            //configvalue = configvalue.replace(/"/g, ""); 
                            configvalue = configvalue.replace(/"/ , ""); 
                            configvalue = configvalue.replace(/"$/,"");
                        }
                    }
                    else
                    {
                        configvalue = configvalueoriginal; 
                    }
                    const configdescr = null;
                    var strTemp = '{"name": "' + configname +'", "value": "' + configvalue +'", "type": "' + configtype +'", "description": "' + configdescr +'"}';
                    if(cnt == lenreal - 1)
                    {
                        if(lenparam > 0 || lenpartitions > 0)
                            configstring = configstring + strTemp + ',';
                        else
                            configstring = configstring + strTemp;
                    }
                    else
                    {
                        configstring = configstring + strTemp + ',';
                    }
                }
            }

            for (var cnt = 0; cnt < that.realParametersConfigurations.length; cnt++)
            {
                if(that.realParametersConfigurations[cnt])
                {
                    var configname = that.realParametersConfigurations[cnt].name.trim();
                    var configtype = that.realParametersConfigurations[cnt].type.trim();
                    var configvalueoriginal = "";
                    if(that.realParametersConfigurations[cnt].value != null && that.realParametersConfigurations[cnt].value != undefined)
                        configvalueoriginal = that.realParametersConfigurations[cnt].value.toString().trim();
                    var configindex = that.realParametersConfigurations[cnt].index;
                    if(configvalueoriginal == undefined)
                        configvalueoriginal="";
                    //if config value contains '\' replace it to '\\'
                    var configvalue = "";
                    if(configtype == "string")
                    {   
                        if(configvalueoriginal.length > 0)
                        {
                            configvalue = JSON.stringify(configvalueoriginal);
                            //configvalue = configvalue.replace(/"/g, ""); 
                            configvalue = configvalue.replace(/"/ , ""); 
                            configvalue = configvalue.replace(/"$/,"");
                        }
                    }
                    else
                    {
                        configvalue = configvalueoriginal; 
                    } 
                                
                    var configdescr = null;
                    var strTemp = '';
                    if(configname.toUpperCase() == "PASSWORD" && configvalue == "*****")
                    {
                        //do not save this value
                    }
                    else
                    {
                        strTemp = '{"name": "' + "repoParam." + configindex + "." + configname +'", "value": "' + configvalue +'", "type": "' + configtype +'", "description": "' + configdescr +'"}';
                    }
                    if(cnt == lenparam - 1)
                    {
                        if(lenpartitions > 0)
                        {
                            if(strTemp != '')
                            {
                                configstring = configstring + strTemp + ',';
                            }
                        }
                        else
                            configstring = configstring + strTemp;
                    }
                    else
                    {
                        if(strTemp != '')
                        {
                            configstring = configstring + strTemp + ',';
                        }
                    }
                }
            }
                    
            for (var cnt = 0; cnt < that.realPartitionsConfigurations.length; cnt++)
            {
                if(that.realPartitionsConfigurations[cnt])
                {
                    const configname = that.realPartitionsConfigurations[cnt].name.trim();
                    const configtype = that.realPartitionsConfigurations[cnt].type.trim();
                    var configvalueoriginal = that.realPartitionsConfigurations[cnt].value.trim();
                    if(configvalueoriginal == undefined)
                        configvalueoriginal="";
                    //if config value contains '\' replace it to '\\'
                    var configvalue = "";
                    if(configtype == "string")
                    {   
                        if(configvalueoriginal.length > 0)
                        {
                            configvalue = JSON.stringify(configvalueoriginal); 
                            //configvalue = configvalue.replace(/"/g, ""); 
                            configvalue = configvalue.replace(/"/ , ""); 
                            configvalue = configvalue.replace(/"$/,"");
                        }
                    }
                    else
                    {
                        configvalue = configvalueoriginal; 
                     }
                    const configindex = that.realPartitionsConfigurations[cnt].index;
                    const configdescr = null;
                    var strTemp = '';
                    if(configname == 'description')
                    {
                        strTemp = '{"name": "repoPartition.' + configindex + '.status", "value": "0", "type": "int", "description": "null"},';
                        configstring = configstring + strTemp;
                        const d = new Date();
                        const dateval = d.toISOString();
                        strTemp = '{"name": "repoPartition.' + configindex + '.statusDate", "value": "", "type": "date", "description": "null"},';
                        configstring = configstring + strTemp;
                        strTemp = '{"name": "repoPartitionTask.' + configindex + '.0.status", "value": "0", "type": "int", "description": "null"},';
                        configstring = configstring + strTemp;
                        strTemp = '{"name": "' + "repoPartition." + configindex +"." + configname +'", "value": "' + configvalue +'", "type": "' + configtype +'", "description": "' + configdescr +'"}';
                    }
                    else
                    {
                        strTemp = '{"name": "' + "repoPartitionTask." + configindex + ".0." + configname +'", "value": "' + configvalue +'", "type": "' + configtype +'", "description": "' + configdescr +'"}';
               
                    }
                    if(cnt == lenpartitions - 1)
                    {
                        configstring = configstring + strTemp;
                    }
                    else
                    {
                        configstring = configstring + strTemp + ',';
                    }
                }
            }

            /*for (var cnt = 0; cnt < that.realPartitionParametersConfigurations.length; cnt++)
            {
                if(that.realPartitionParametersConfigurations[cnt])
                {
                    const configname = that.realPartitionParametersConfigurations[cnt].name.trim();
                    const configtype = that.realPartitionParametersConfigurations[cnt].type.trim();
                    var configvalueoriginal = that.realPartitionParametersConfigurations[cnt].value.trim();
                    if(configvalueoriginal == undefined)
                        configvalueoriginal="";
                    //if config value contains '\' replace it to '\\'
                    var configvalue = "";
                    if(configtype == "string")
                    {   
                        if(configvalueoriginal.length > 0)
                        {
                            configvalue = JSON.stringify(configvalueoriginal); 
                            //configvalue = configvalue.replace(/"/g, ""); 
                            configvalue = configvalue.replace(/"/ , ""); 
                            configvalue = configvalue.replace(/"$/,"");
                        }
                    }
                    else
                    {
                        configvalue = configvalueoriginal; 
                    }
                    const configindex = that.realPartitionParametersConfigurations[cnt].index;
                    const parentindex = that.realPartitionParametersConfigurations[cnt].parentindex;
                    const configdescr = null;
                    const strTemp = '{"name": "' + "repoPartitionTask." + parentindex + "." + configindex +"." + configname +'", "value": "' + configvalue +'", "type": "' + configtype +'", "description": "' + configdescr +'"}';
                    if(cnt == lenconfparam - 1)
                    {
                        configstring = configstring + strTemp;
                    }
                    else
                    {
                        configstring = configstring + strTemp + ',';
                    }
                }
            }
               */     
            var str = configstring;
            var res1 = str.charAt(str.length-1)
            if(res1 == ',')
            {
                configstring = str.slice(0,str.length-1);
            }
            res1 = str.charAt(str.length-1)
            if(res1 == ',')
            {
                tempstring = str.slice(0,str.length-1);
            }
            const connString = '"configData":[';
            const connStringend = ']}';
            //{"configData": [ + confstring + ] }
            const res = connString.concat(configstring, connStringend);
            var configdescr='';
            if(that.ecmRepository.attributes.description)
            {
                if(that.ecmRepository.attributes.description.length > 0)
                {
                    configdescr = JSON.stringify(that.ecmRepository.attributes.description); 
                    //configdescr = configdescr.replace(/"/g, ""); 
                    configdescr = configdescr.replace(/"/ , ""); 
                    configdescr = configdescr.replace(/"$/,"");
                } 
            }
            const propstring = '{"repositoryId": "' + that.ecmRepository.attributes.repositoryId + '", "repositoryName": "' + that.ecmRepository.attributes.repositoryName + '", "repositoryType": "' + that.ecmRepository.attributes.repositoryType + '", "description": "' + configdescr + '", ' + res;
            return {connString:propstring, returnedstring:tempstring};
        },

        getlastindexitem:function(index)
        {
            var cnt = 0;
            if(this.realParametersConfigurations)
            {
                for (cnt = 0; cnt < this.realParametersConfigurations.length; cnt++)
                {
                    const entryValue = this.realParametersConfigurations[cnt];
                    if (entryValue)
                    {
                        const curindex = entryValue.index;
                        if(curindex > index)
                        {
                            const res = Number(cnt);
                            return res;
                        }
                    }
                }
            }
            return cnt;
        },
       
       getlastindex:function()
        {
            var cnt = 0;
            var index = -1;
            if(this.realParametersConfigurations)
            {
                for (cnt = 0; cnt < this.realParametersConfigurations.length; cnt++)
                {
                    var entryValue = this.realParametersConfigurations[cnt];
                    if (entryValue)
                    {
                        var curindex = entryValue.index;
                        if(Number(curindex) > Number(index))
                        {
                            index = curindex;
                        }
                    }
                }
            }
            return index;
        },
        
        InitParameters()
        {
            //here is list of all saved attributes in one collection
            //we will fill all four original and for different tabs based on names
            //on init first time init realcollections as well
            var that = this;
            if(that.ecmRepository)
            {
                const childNodes = that.ecmRepository.attributes.configData;
                if(childNodes)
                {
                    const len = childNodes.length;
                    for(var i=0; i<len; i++)
                    {
                        const oneelement = childNodes[i];
                        if(oneelement)
                        {
                            var paramName = oneelement.name;
                            var paramIndex = 0;//for partitions
                            var parentindex = 0;
                            //parse name to see what we have
                            //could be one word
                            //repoParam.0.hostName, repoPartitionTask.0.folderPathOrId
                            const namesArray = paramName.split(".");
                            var onename = false;
                            var parametername = false;
                            var jobname = false;
                            var jobparams = false;
                            
                            const lennames = namesArray.length;
                            if(lennames == 1)
                            {
                                onename = true;
                            }
                            else
                            {
                                if (namesArray[0] == "repoParam")
                                {
                                    parametername = true;
                                    paramIndex = namesArray[1]; 
                                    paramName = namesArray[2]; 
                                }
                                else if (namesArray[0] == "repoPartitionTask")
                                {
                                    jobparams = true;
                                    parentindex = namesArray[1]; 
                                    paramIndex = namesArray[1]; //namesArray[2] always 0
                                    paramName = namesArray[3]; 
                                }   
                                else if (namesArray[0] == "repoPartition")
                                {
                                    jobname = true;
                                    paramIndex = namesArray[1]; 
                                    paramName = namesArray[2]; 
                                }
                            }
                            const paramType = oneelement.type;
                        
                            var defaultvalue = "";
                            if(oneelement.defaultValue)
                            {
                                defaultvalue = oneelement.defaultValue;
                            }
                            if(defaultvalue == undefined)
                                defaultvalue = "";
                                
                            var paramValue = "";
                            if(oneelement.value)
                                paramValue = oneelement.value;
                            var minoccurs = 0;
                            if(oneelement.minOccurs)
                                minoccurs = oneelement.minOccurs;
                            if(minoccurs == undefined)
                                minoccurs = 0;
                            const mandatoryvalue = minoccurs;
                                
                            var maxoccurs = 1;
                            if(oneelement.maxOccurs)
                                maxoccurs = oneelement.maxOccurs;
                            if(maxoccurs == undefined)
                                maxoccurs = 1;
                            var minValue = oneelement.minValue; 
                            var maxValue = oneelement.maxValue;   
                                            
                            if(onename == true)
                            {
                                that.realConfigurations.push({"name" : paramName, "type" : paramType, "value": paramValue, "defaultvalue": defaultvalue, "mandatory" : mandatoryvalue, "index" :paramIndex});
                            }
                            if(parametername == true)
                            {
                                if((paramName).toUpperCase() == "PASSWORD")
                                {
                                    that.realParametersConfigurations.unshift({"name" : paramName, "type" : paramType, "value": "*****", "defaultvalue": defaultvalue, "mandatory" : mandatoryvalue, "index" :paramIndex});
                                }
                                else
                                {                                   
                                    that.realParametersConfigurations.push({"name" : paramName, "type" : paramType, "value": paramValue, "defaultvalue": defaultvalue, "mandatory" : mandatoryvalue, "index" :paramIndex});
                                }
                            }
                            if(jobname == true || jobparams == true)
                            {
                                if(paramName != 'status' && paramName != 'statusDate')
                                    that.realPartitionsConfigurations.push({"name" : paramName, "type" : paramType, "value": paramValue, "defaultvalue": defaultvalue, "mandatory" : mandatoryvalue, "index" :paramIndex});
                            }
                        }
                    }//end for
                }
            }
        },

        InitAvailableAndMandatory()
        {
            const childNodes = this.parametersFromGrammar;
            if(childNodes)
            {
                const len = childNodes.length;
                for(var i=0; i<len; i++)
                {
                    const oneelement = childNodes[i];
                    if(oneelement)
                    {
                        var paramName = oneelement.name;
                        //parse name to see what we have
                        //could be one word
                        //repoParam.0.hostName, repoPartitionTask.0.folderPathOrId, repoExcludedFolder.1.folderPathOrId
                        const namesArray = paramName.split(".");
                        var onename = false;
                        var parametername = false;
                        var jobname = false;
                        var jobparams = false;
                        
                        const lennames = namesArray.length;
                        
                        if(lennames == 1)
                        {
                            onename = true;
                        }
                        else
                        {
                            if (namesArray[0] == "repoParam")
                            {
                                parametername = true;
                                paramName = namesArray[1]; 
                            }
                            else if (namesArray[0] == "repoPartition")
                            {
                                jobname = true;
                                paramName = namesArray[1]; 
                            }
                            else if (namesArray[0] == "repoPartitionTask")
                            {
                                jobparams = true;
                                paramName = namesArray[1]; 
                            }
                        }
                        const paramType = oneelement.type;
                        var defaultvalue = "";
                        if(oneelement.defaultValue)
                        {
                            defaultvalue = oneelement.defaultValue;
                        }
                        if(defaultvalue == undefined)
                            defaultvalue = "";
                                
                        var paramValue = "";
                        if(oneelement.value)
                            paramValue = oneelement.value;
                        var minoccurs = 0;
                        if(oneelement.minOccurs)
                            minoccurs = oneelement.minOccurs;
                        if(minoccurs == undefined)
                          minoccurs = 0;
                        var mandatoryvalue = minoccurs;
                        var maxoccurs = 1;
                        if(oneelement.maxOccurs)
                            maxoccurs = oneelement.maxOccurs;
                        if(maxoccurs == undefined)
                            maxoccurs = 1;
                        var minValue = oneelement.minValue; 
                        var maxValue = oneelement.maxValue;   
                          
                        if(onename == true)
                        {
                            //nothing
                        }
                        if(parametername == true)
                        {
                            this.availableParametersConfigurations.push({"name" : paramName, "type" : paramType, "value": defaultvalue, "defaultvalue": defaultvalue, "mandatory" : mandatoryvalue, "minValue" : minValue, "maxValue" :maxValue});
                            if(minoccurs == 1) //mandatory
                            {
                                if (this.realParametersConfigurations && this.realParametersConfigurations.length > 0)
                                {
                                    var result = this.realParametersConfigurations.filter((el) => (el.name == paramName));
                                    if (result != undefined && result.length == 0)
                                    {
                                        // not found
                                    }
                                    else if (result != undefined && result.length == 1)
                                    {
                                        result[0].mandatory = mandatoryvalue;
                                    } 
                                    else if(result != undefined)
                                    {
                                        const count = result.length;var cntx=0;
                                        for (cntx = 0; cntx < count; cntx++)
                                        {
                                            result[cntx].mandatory = mandatoryvalue;
                                        }
                                    }
                                }
                            }
                        }
                        if(jobname == true || jobparams == true)
                        {
                            this.availablePartitionsConfigurations.push({"name" : paramName, "type" : paramType, "value": defaultvalue, "defaultvalue": defaultvalue, "mandatory" : mandatoryvalue, "minValue" : minValue, "maxValue" :maxValue});
                            
                            if(minoccurs == 1 ||  paramName == 'description') //mandatory
                            {
                                mandatoryvalue = 1;
                                if (this.realPartitionsConfigurations && this.realPartitionsConfigurations.length > 0)
                                {
                                    var result = this.realPartitionsConfigurations.filter((el) => (el.name == paramName));
                                    if (result != undefined && result.length == 0)
                                    {
                                      // not found
                                    }
                                    else if (result != undefined && result.length == 1)
                                    {
                                        result[0].mandatory = mandatoryvalue;
                                    } 
                                    else if(result != undefined)
                                    {
                                        const count = result.length;var cntx=0;
                                        for (cntx = 0; cntx < count; cntx++)
                                        {
                                            result[cntx].mandatory = mandatoryvalue;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
   
    created() {
        var that = this;
        Promise.all([
                that.ecmRepository.fetch(that.id, {"Content-Type": "application/json; charset=UTF-8"}),
            ]).then(() => {
                that.InitParameters();
                that.ecmRepositoryType.fetch(that.ecmRepository.attributes.repositoryType, {"Content-Type": "application/json; charset=UTF-8"})
                    .then(() => {
                        that.parametersFromGrammar = that.ecmRepositoryType.attributes.configTypes;
                        //try *******************************************************
                        for (var cnt = 0; cnt < that.parametersFromGrammar.length; cnt++)
                        {
                            if(that.parametersFromGrammar[cnt])
                            {
                                const configname = that.parametersFromGrammar[cnt].name.trim();
                                if(configname == 'repoParam.extractACL')
                                {
                                    that.parametersFromGrammar[cnt].mandatory = true;
                                    that.parametersFromGrammar[cnt].defaultValue = 2;
                                    that.parametersFromGrammar[cnt].maxOccurs = 1;
                                    that.parametersFromGrammar[cnt].maxValue = 2;
                                    that.parametersFromGrammar[cnt].minValue=0;
                                    that.parametersFromGrammar[cnt].minOccurs = 1;
                                }
                            }
                        }

                        //************************************************************/
                        that.InitAvailableAndMandatory();
                })
                .catch((err) => {
                    console.log(err);
                    that.loaded = true;
                });
            
                that.loaded = true;
                that.ecmRepository.on('saving', that.savingECMRepository);
                that.ecmRepository.on('saved', that.savedECMRepository);
                that.ecmRepository.on('error', that.ECMRepositoryError);
                that.ecmRepository.on('not-found', that.ECMRepositoryNotFound);
            })
            .catch((err) => {
                console.log(err);
                that.loaded = true;
            });
       
    },
    
    beforeDestroy() {
        this.ecmRepository.off('saving', this.savingECMRepository);
        this.ecmRepository.off('saved', this.savedECMRepository);
        this.ecmRepository.off('error', this.ECMRepositoryError);
        this.ecmRepository.off('not-found', this.ECMRepositoryNotFound);
    }
}
</script>

